import { instance } from "apis/interceptor";
import { TVisit, TVisitInfo, TVisitedRecordRes } from "./type";
import * as Sentry from "@sentry/react";

type ResponseType<T> = {
    success: boolean;
    statusCode?: number;
    message?: string;
    data?: T;
};

//INFO: (new) 방문 기록 조회
export async function getVisitRecord(visitId: string): Promise<ResponseType<TVisit>> {
    try {
        const res = await instance.post("/visitors/record", {
            id: visitId,
        });
        return { success: true, data: res.data };
    } catch (error: any) {
        const status = error.response?.status;
        if (status === 423) {
            return { success: false, message: "접근 권한이 없습니다." };
        } else {
            return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
        }
    }
}

//INFO: (new) 임직원 사전 방문 등록
export async function saveVisitInfo(visitorInfo: TVisitInfo): Promise<ResponseType<TVisitInfo>> {
    try {
        const res = await instance.post("/visitors/record/host", visitorInfo);
        return { success: true, data: res.data };
    } catch (error: any) {
        Sentry.captureException(error, { extra: visitorInfo });
        const status = error.response?.status;
        if (status === 409) {
            return { success: false, message: "이미 등록된 일정이 있습니다." };
        } else if (status === 423) {
            return { success: false, message: "접근 권한이 없습니다." };
        } else {
            return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
        }
    }
}

//INFO: (new) 본인 담당 방문 기록 수정
export async function updateVisitInfo(visitorInfo: TVisitInfo): Promise<ResponseType<TVisit>> {
    try {
        const res = await instance.patch("/visitors/record", visitorInfo);
        return { success: true, data: res.data };
    } catch (error: any) {
        Sentry.captureException(error, { extra: visitorInfo });
        const status = error.response?.status;
        if (status === 409) {
            return { success: false, message: "이미 등록된 일정이 있습니다." };
        } else if (status === 423) {
            return { success: false, message: "접근 권한이 없습니다." };
        } else {
            return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
        }
    }
}

//INFO: (new) 방문자 기록 삭제
export async function deleteVisit(id: string): Promise<ResponseType<boolean>> {
    try {
        const res = await instance.delete("/visitors/record", {
            data: {
                id: id,
            },
        });

        return { success: res.data.result };
    } catch (error) {
        Sentry.captureException(error, { extra: { id: id } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요."};
    }
}

//INFO: (new) 지난 방문 기록 조회
export async function getVisitRecordCompleted(page: number): Promise<ResponseType<TVisitedRecordRes>> {
    try {
        const res = await instance.post(`/visitors/record/completed`, { nowPageNumber: page });
        return { success: true, data: res.data};
    } catch (error: any) {
        Sentry.captureException(error, { extra: { page: page } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
}

//INFO: (new) 오늘 방문 예정 기록 조회
export async function getVisitRecordToday(page: number): Promise<ResponseType<TVisitedRecordRes>> {
    try {
        const res = await instance.post(`/visitors/record/today`, { nowPageNumber: page });
        return { success: true, data: res.data};
    } catch (error: any) {
        Sentry.captureException(error, { extra: { page: page } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
}

//INFO: (new) 예정된 방문 기록 조회
export async function getVisitRecordUpcoming(page: number): Promise<ResponseType<TVisitedRecordRes>> {
    try {
        const res = await instance.post(`/visitors/record/upcoming`, { nowPageNumber: page });
        return { success: true, data: res.data};
    } catch (error: any) {
        Sentry.captureException(error, { extra: { page: page } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
}

//INFO: (new) 대기 중인 방문 요청 조회
export async function getPendingRecordList(page: number): Promise<ResponseType<TVisitedRecordRes>> {
    try {
        const res = await instance.post(`/visitors/record/pending`, { nowPageNumber: page });
        return { success: true, data: res.data};
    } catch (error: any) {
        Sentry.captureException(error, { extra: { page: page } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
}

//INFO: (new) 방문 등록 허용
export const acceptPendingRecord = async (id: string): Promise<ResponseType<boolean>> => {
    try {
        const res = await instance.patch("/visitors/record/pending/accept", {
            id: id,
        });
        return { success: res.data.result };
    } catch (error) {
        Sentry.captureException(error, { extra: { id: id } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};

//INFO: (new) 방문 등록 허용
export const rejectPendingRecord = async (id: string): Promise<ResponseType<boolean>> => {
    try {
        const res = await instance.patch("/visitors/record/pending/reject", {
            id: id,
        });
        return { success: res.data.result };
    } catch (error) {
        Sentry.captureException(error, { extra: { id: id } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};